import script from "./FlowEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlowEditor.vue?vue&type=script&lang=ts&setup=true"

import "./FlowEditor.vue?vue&type=style&index=0&id=6a72059c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a72059c"]])

export default __exports__